module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921130834_T.fa0819e6.jpg";